import React from "react";
import "./style.scss";
import { useGetAboutPageContentQuery } from "../../../../services/AboutAPI";
import Loader from "../../fullPageLoader"
import { useGetColorThemeQuery } from "../../../../services/commonAPI";

function Index() {
  const {
    data: aboutContent,
    error: contentError,
    isLoading: contentLoading,
  } = useGetAboutPageContentQuery(); 

    const {
          data: colorthemeData,
      } = useGetColorThemeQuery();

  if (contentLoading) return <Loader />;
  if (contentError) return <p>Failed to load page content</p>;

  // Get the first section of the about content
  const aboutSection = aboutContent?.data?.[0];

  return (
    <>
      {aboutSection && aboutSection?.is_section_one_active === 1 && (
        <div className="section-1">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-sm-6 col-lg-6 left-sec">
                <h4 style={{ color: colorthemeData?.color_themes?.[0]?.heading_color || "#000" }} data-aos="fade-right">{aboutSection.section_one_heading}</h4>
                {/* <p style={{ color: colorthemeData?.color_themes?.[0]?.paragraph_color || "##767676" }} data-aos="fade-right">{aboutSection.section_one_text}</p> */}

                <div
                 data-aos="fade-left"
                  dangerouslySetInnerHTML={{
                    __html: aboutSection.section_one_text,
                  }}
                />
              </div>
              <div className="col-md-12 col-sm-6 col-lg-6">
                <div class="image-container">
                  <img
                    src={aboutSection.section_one_image}
                    alt="section-image"
                    className="img-fluid"
                    loading="lazy"
                    data-aos="fade-left"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Index;
